/* Handle quantity change styling */
(function () {
  document.addEventListener('DOMContentLoaded', () => {
    // Helpers
    function setupQuantityChangeListeners() {
      const quantityWrappers = document.querySelectorAll('.quantity__wrapper--custom');
      quantityWrappers.forEach((wrapper) => {
        const buttons = wrapper.querySelectorAll('.quantity__button');
        buttons.forEach((button) => {
          button.addEventListener('click', () => {
            wrapper.setAttribute('data-selected', 'true');
          });
        });
      });
    }

    function setupMutationObserver() {
      const cartLinesContainer = document.querySelector('div[data-line-items]');
      const observer = new MutationObserver(function(mutationList) {
        for (const mutation of mutationList) {
          const isContentInjected = (mutation.type === 'childList' && mutation.addedNodes.length > 0);
          if (isContentInjected) {
            setupQuantityChangeListeners();
          }
        }
      });
  
      observer.observe(cartLinesContainer, { childList: true });
    }

    // Main
    setupMutationObserver();
    setupQuantityChangeListeners(); // First page load
  });
})();